import React from 'react';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ConstructionBanner } from '@/components/ConstructionBanner';
import { Home } from '@/pages/Home';
import { MailClients } from '@/pages/MailClients';
import { NotFound } from '@/pages/NotFound';
import { useAppSelector } from '@/app/hooks';

export const App: React.FC = () => {
  const path = window.location.pathname;
  const { checked, authenticated } = useAppSelector((state) => state.auth);

  let page: React.ReactNode;
  if (path === '/') {
    page = <Home />;
  } else if (path === '/mail-clients') {
    page = checked ? (authenticated ? <MailClients /> : <NotFound />) : null;
  } else {
    page = <NotFound />;
  }

  return (
    <>
      <Header />
      {path === '/' && <ConstructionBanner />}
      {page}
      <Footer />
    </>
  );
};
